import { useSuggestedResourcesStoreProps } from './ui/load-if-needed/utils.tsx';

export const useIsSuggestedResourcesShown = () => Boolean(useSuggestedResourcesStoreProps());
